import { setContext } from "@apollo/client/link/context";
import { getCachedDeviceInfo } from "src/lib/device";
const studioClientIDLink = setContext(async (_, context) => {
    let deviceInfo;
    try {
        deviceInfo = await getCachedDeviceInfo();
    }
    catch (error) {
        console.error('Failed to get device info for Apollo headers:', error);
        deviceInfo = { osType: 'unknown', appVersion: '', codePushVersion: '' };
    }
    return {
        ...context,
        headers: {
            ...context.headers,
            'apollographql-client-name': deviceInfo.osType,
            'apollographql-client-version': [
                deviceInfo.appVersion,
                deviceInfo.codePushVersion,
            ]
                .filter(Boolean)
                .join('_'),
        },
    };
});
export default studioClientIDLink;
